import $ from 'jquery';

$(function () {


  $('.footer-menu__item .arrow').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.footer-menu__item').toggleClass('active');
    $(this).closest('.footer-menu__item').find('.sub-menu').toggleClass('active');
  });

});




